import React from "react";
import { Provider } from "react-redux";
import store from './store';
import { PackProvider } from "./contexts/PackContext";
import { IntegrationsProvider } from "./state/integrations";
import Routes from "./Routes";

// Memoize Routes to prevent unnecessary re-renders when context values change
const MemoizedRoutes = React.memo(Routes);

function App() {
  return (
    <Provider store={store}>
      <PackProvider>
        <IntegrationsProvider>
          <MemoizedRoutes />
        </IntegrationsProvider>
      </PackProvider>
    </Provider>
  );
}

export default App;